import _classCallCheck from "/build-directory/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build-directory/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/build-directory/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build-directory/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/build-directory/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/build-directory/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { PureComponent } from 'react';
import { getDisplayTimeBySeconds } from './utils';
var Duration = /*#__PURE__*/function (_PureComponent) {
  function Duration(props) {
    var _this;
    _classCallCheck(this, Duration);
    _this = _callSuper(this, Duration, [props]);
    _defineProperty(_this, "hasAddedAudioEventListener", false);
    _defineProperty(_this, "state", function () {
      return {
        duration: _this.props.audio ? getDisplayTimeBySeconds(_this.props.audio.duration, _this.props.audio.duration, _this.props.timeFormat) : _this.props.defaultDuration
      };
    }());
    _defineProperty(_this, "handleAudioDurationChange", function (e) {
      var audio = e.target;
      var _this$props = _this.props,
        timeFormat = _this$props.timeFormat,
        defaultDuration = _this$props.defaultDuration;
      _this.setState({
        duration: getDisplayTimeBySeconds(audio.duration, audio.duration, timeFormat) || defaultDuration
      });
    });
    _defineProperty(_this, "addAudioEventListeners", function () {
      var audio = _this.props.audio;
      if (audio && !_this.hasAddedAudioEventListener) {
        _this.audio = audio;
        _this.hasAddedAudioEventListener = true;
        audio.addEventListener('durationchange', _this.handleAudioDurationChange);
        audio.addEventListener('abort', _this.handleAudioDurationChange);
      }
    });
    var _audio = props.audio,
      _timeFormat = props.timeFormat,
      _defaultDuration = props.defaultDuration;
    _this.state = {
      duration: _audio ? getDisplayTimeBySeconds(_audio.duration, _audio.duration, _timeFormat) : _defaultDuration
    };
    return _this;
  }
  _inherits(Duration, _PureComponent);
  return _createClass(Duration, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addAudioEventListeners();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.addAudioEventListeners();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.audio && this.hasAddedAudioEventListener) {
        this.audio.removeEventListener('durationchange', this.handleAudioDurationChange);
        this.audio.removeEventListener('abort', this.handleAudioDurationChange);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.duration;
    }
  }]);
}(PureComponent);
export default Duration;